import { render, staticRenderFns } from "./okxTransaction.vue?vue&type=template&id=6f39640f&scoped=true&"
import script from "./okxTransaction.vue?vue&type=script&lang=js&"
export * from "./okxTransaction.vue?vue&type=script&lang=js&"
import style0 from "./okxTransaction.vue?vue&type=style&index=0&id=6f39640f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39640f",
  null
  
)

export default component.exports